import axios from 'axios'
import { env } from '../../../config/environment'

export const fetchRiders = async (lat, lng, provider) => {
	try {
		const url = `${env.apiUrl}/riders/provider/loc`
		const response = await axios.post(url, { lat, lng, provider})
		return response.data
	} catch (error) {
		console.error(`Error in fetching riders:`,error)
	}
}

export const fetchRidersByPartner = async (id) => {
	try {
		const response = await axios.get(
			`${env.apiUrl}/riders/provider?provider=${id}`
		)
		return response.data
	} catch (error) {
		console.error(`Error in fetching riders by delivery company:`,error)
	}
}

export const createRider = async (body) => {
	console.log("🚀 ~ createRider ~ body:", body)
	try {
		const response = await axios.post(`${env.apiUrl}/riders`, body)
		return response.data
	} catch (error) {
		console.error(`Error in create rider:`,error)
	}
}

export const updateRider = async (id, body) => {
	try {
		const response = await axios.put(`${env.apiUrl}/riders?ID=${id}`, body)
		return response.data
	} catch (error) {
		console.error(`Error in update rider:`,error)
	}
}

export const deleteRider = async (id, body) => {
	try {
		const response = await axios.put(`${env.apiUrl}/riders?ID=${id}`, body)
		return response.data
	} catch (error) {
		console.error(`Error in delete rider:`,error)
	}
}

export const assignRider = async (id, body) => {
	try {
		const response = await axios.patch(
			`${env.apiUrl}/orders/rider/set?ID=${id}`,
			body
		)
		return response.data
	} catch (error) {
		console.error(`Error in assign rider to order:`,error)
	}
}

export const assignRiderErrand = async (id, body) => {
	try {
		const response = await axios.put(
			`${env.apiUrl}/errands/rider/set?ID=${id}`,
			body
		)
		return response.data
	} catch (error) {
		console.error(`Error in assing rider to errand:`,error)
	}
}

export const fetchRiderByDocuments = async (doc) => {
	try {
		const response = await axios.get(`${env.apiUrl}/riders/document?doc=${doc}`)
		return response.data
	} catch (error) {
		console.error(`Error in fetching rider by documents:`,error)
	}
}

export const registerRiderPayment = async (id, body) => {
	try {
		const response = await axios.post(`${env.apiUrl}/rider-payments`, body)
		return response.data
	} catch (error) {
		console.error(`Error in registering rider payment:`,error)
	}
}

export const getRiderPayments = async (partner, from, to) => {
	try {
		const response = await axios.get(`${env.apiUrl}/rider-payments/partner?partner=${partner}&from=${from}&to=${to}`)
		return response.data
	} catch (error) {
		console.error(`Error in getting rider payments:`,error)
	}
}
